import React, { useEffect, useState } from "react";
import { Box, Button, InputLabel, Stack, TextField, Autocomplete, Typography } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import { Member } from "../../Models/Member.ts";
import { MEMBER_TYPE, MEMBER_TYPE_CASES, MEMBER_CATEGORY_CASES } from "../../Models/StateConstants.ts";
import { addOrUpdateUser } from "../../Requests/UserService.ts";
import dayjs from "dayjs";
import AvatarDropzone from "../StyledComponents/AvatarDropzone/AvatarDropzone";



export default function AddMember(props) {

  const [avatar, setAvatar] = useState()
  const [name, setName] = useState("")
  const [surname, setSurname] = useState("")
  const [email, setEmail] = useState("")
  const [phoneNumber, setPhoneNumber] = useState("")
  const [organization, setOrganization] = useState("")
  const [position, setPosition] = useState("")
  const [password, setPassword] = useState("")
  const [membershipValidStart, setMembershipValidStart] = useState()
  const [membershipValidUntil, setMembershipValidUntil] = useState()
  const [about, setAbout] = useState("")
  const [memberType, setMemberType] = useState("")
  const [memberCategory, setMemberCategory] = useState("")
  const [gender, setGender] = useState("")

  const [hidePasswordField, setHidePasswordField] = useState(false)
  useEffect(() => {
    setHidePasswordField(memberType === MEMBER_TYPE.DRAFT)
  }, [memberType])

  const handlePublish = async () => {
    let object = new Member()
    object.name = name
    object.surname = surname
    object.email = email
    object.phoneNumber = phoneNumber
    object.organization = organization
    object.position = position
    object.password = (memberType === MEMBER_TYPE.DRAFT) ? "1234" : password
    object.membershipValidStart = dayjs(membershipValidStart).toDate()
    object.membershipValidUntil = dayjs(membershipValidUntil).toDate()
    object.about = about
    object.memberType = memberType
    object.memberCategory = memberCategory
    object.gender = gender
    await addOrUpdateUser(object, avatar)
    props.publish()
  }


  return (
    <Box sx={{ p: 3 }}>
      <Box>
        <AvatarDropzone
          title={"Member Avatar"}
          callbackFile={(file) => { setAvatar(file) }}
        />

        <Stack
          spacing={1}
          marginTop={4}
        >
          <InputLabel>{"Member Type"}</InputLabel>
          <Autocomplete
            options={MEMBER_TYPE_CASES}
            renderInput={(params) => <TextField {...params} />}
            onChange={(event) => setMemberType(event.target.textContent)}
          />
        </Stack>

        <Stack
          spacing={1}
          marginTop={4}
        >
          <InputLabel>{"First Name"}</InputLabel>
          <TextField
            placeholder="First Name"
            value={name}
            onChange={(event) => setName(event.target.value)}
          />
        </Stack>

        <Stack
          spacing={1}
          marginTop={4}
        >
          <InputLabel>{"Last Name"}</InputLabel>
          <TextField
            placeholder="Last Name"
            value={surname}
            onChange={(event) => setSurname(event.target.value)}
          />
        </Stack>

        <Stack
          spacing={1}
          marginTop={4}
        >
          <InputLabel>{"Email Address"}</InputLabel>
          <TextField
            placeholder="Email Address"
            value={email}
            onChange={(event) => setEmail(event.target.value)}
          />
        </Stack>

        <Stack
          spacing={1}
          marginTop={4}
        >
          <InputLabel>{"Phone Number"}</InputLabel>
          <TextField
            placeholder="Phone Number"
            value={phoneNumber}
            onChange={(event) => setPhoneNumber(event.target.value)}
          />
        </Stack>

        <Stack
          spacing={1}
          marginTop={4}
        >
          <InputLabel>{"Organization"}</InputLabel>
          <TextField
            placeholder="Organization"
            value={organization}
            onChange={(event) => setOrganization(event.target.value)}
          />
        </Stack>

        <Stack
          spacing={1}
          marginTop={4}
        >
          <InputLabel>{"Position"}</InputLabel>
          <TextField
            placeholder="Position"
            value={position}
            onChange={(event) => setPosition(event.target.value)}
          />
        </Stack>

        <Box
          hidden={hidePasswordField}
        >
          <Stack
            spacing={1}
            marginTop={4}
          >
            <InputLabel>{"Temporary password"}</InputLabel>
            <TextField
              placeholder="Temporary password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
            />
          </Stack>
        </Box>

        <Stack
          spacing={1}
          marginTop={4}
        >
          <InputLabel>About</InputLabel>
          <TextField
            placeholder="About"
            value={about}
            onChange={(event) => setAbout(event.target.value)}
            multiline
            minRows={6}
          />
        </Stack>

        <Stack
          spacing={1}
          marginTop={4}
        >
          <InputLabel>{"Gender"}</InputLabel>
          <TextField
            select
            value={gender}
            onChange={(e) => setGender(e.target.value)}
            SelectProps={{ native: true }}
          >
            <option value="">Select gender</option>
            <option value="male">Male</option>
            <option value="female">Female</option>
          </TextField>
        </Stack>

        <Stack
          spacing={1}
          marginTop={4}
        >
          <Typography
            variant="h6"
          >
            Membership
          </Typography>
        </Stack>

        <Stack
          spacing={1}
          marginTop={4}
        >
          <InputLabel>{"Member Category"}</InputLabel>
          <Autocomplete
            options={MEMBER_CATEGORY_CASES}
            renderInput={(params) => <TextField {...params} />}
            onChange={(event) => setMemberCategory(event.target.textContent)}
          />
        </Stack>

        <Box
          sx={{
            display: "flex",
            gap: 1
          }}
        >
          <Stack
            spacing={1}
            marginTop={4}
          >
            <InputLabel>{"Membership Start Date"}</InputLabel>
            <DatePicker
              format="DD/MM/YYYY"
              onChange={(newValue) => setMembershipValidStart(newValue)}
            />
          </Stack>

          <Stack
            spacing={1}
            marginTop={4}
          >
            <InputLabel>{"Membership Renewal Date"}</InputLabel>
            <DatePicker
              format="DD/MM/YYYY"
              onChange={(newValue) => setMembershipValidUntil(newValue)}
            />
          </Stack>
        </Box>
      </Box>

      <Box
        display="flex"
        justifyContent="right"
        marginTop={4}
      >
        <Button
          variant="contained"
          size="large"
          onClick={() => handlePublish()}
        >
          {"Publish"}
        </Button>
      </Box>
    </Box>
  )
}
